import { IAdminMinerProof } from "@services/getMinerList";
import { IMinerProfile } from "@store/minerProfiles/reducer";
import { ResponseStatus } from "../responses/BaseResponse";
import { ALGOS_E } from "@constants/Algos";
import { IPoolCreds } from "@services/getSettings";

export enum SocketEventTypes {
  SET_PROCESSED = 0,
  // Состояния
  //MINER_STATUS = 1, // deprecated
  // Скорость майнера
  MINER_HASRATE = 2,
  // Старт/стоп майнинга на админа
  MINER_ADMIN_START_STOP = 3,
  // Старт/стоп майнера
  MINER_START_STOP = 4,
  // Скорость по настройке для графика:
  MINER_SETTINGS_SPEED = 5, // почему-то и для графика клиента шлется.
  // Скорость по хешу для графика:
  MINER_HASH_SPEED = 6, // algo
  // Настройка майнера. Изменение miner ID:
  MINER_ID = 7,
  // Настройка майнера. Изменение типа:
  MINER_TYPE = 8,
  // Настройка майнера. Изменение default speed:
  MINER_DEFAULT_SPEED = 9,
  // Настройка майнера. Изменение drop speed:
  MINER_DROP_SPEED = 10,
  // Настройка майнера. Изменение настройки:
  MINER_SETTINGS = 11,
  // Настройка майнера. Изменение кастомера:
  MINER_CUSTOMER = 12,
  // Настройка майнера. Изменение плана:
  MINER_PLAN = 13,
  // Настройка майнера. Изменение процентов:
  MINER_PERCENT = 14,

  NEED_LOGON = 15,

  MINER_SMOOTH = 20,

  RACK_ITEM_ADD = 21,

  CHANGE_USER_COLOR = 22,
  // Изменение локации:
  MINER_LOCATION = 23,
  SMT_MINER_CHAT = 24,

  LOCATION_SPEED = 25,
  MINER_COMMAND_RESULT = 27,
  USER_SETTING = 30,
}

export interface ChartValueEvent {
  id: number;
  miner_id?: string | null;
  pool_id?: string | null;
  algo?: string | null;
  is_total?: boolean | null;
  value: number;
  time: number;
}

//
// {
//   "type":5,
//   "user_id":17454,
//   "event": {
//     "id":"sha256",
//     "is_total":true,
//     "hash":"sha256",
//     "speed":208505210404864,
//     "accepted":261234,
//     "rejected":173,
//     "created":1750080120
//   }
// }
export interface SocketMessage<T> {
  id: number;
  message?: string; //`json:",omitempty"` //если status==error, содержит текст ошибки
  type?: SocketEventTypes;
  event: T;
  error?: string;
  code?: number; // 403
  status?: ResponseStatus; // string `json:",omitempty"`
  user_id?: number;
}

export interface UserSettingEvent {
  id: number;
  user_id: number;
  email: string;
  name: string; // setting name
  hash: ALGOS_E;
  pools: IPoolCreds[];
  used_count: number;
  is_default: boolean;
}

export interface UserChartEvent {
  id: string;
  is_total: boolean; // true for admin
  hash: string;
  speed: number;
  accepted: number;
  rejected: number;
  created: number; //1750080120
}

export interface MinerBaseEvent<TId> {
  id: TId; //string | undefined; // miner id or pool_id
  created: number; // unixtime sec
}

export interface MinerCommandResult extends MinerBaseEvent<number> {
  command: string;
  data: any;
  status: string; // done,
  //created: number;
}
export interface ISpeedMessage extends MinerBaseEvent<string | undefined> {
  speed: number;
}

export interface LocationSpeedMessage extends ISpeedMessage {
}
export interface MinerStatusEvent extends MinerBaseEvent<string | undefined> {
  state: number;
}

export interface UserBaseEvent {
  user_id: number;
  created: number; // unixtime sec
}

// Хэшрейт майнера
// Type=2
// {"id":1665497388005627816,"type":2,"event":{"id":"a2646ce858f7","speed":76060793706701.61,"created":1665497388}}
export interface MinerHashEvent extends ISpeedMessage {
  rejected: number;
  accepted: number;
  state: number;
}

export interface MinerSettingsSpeedEvent extends ISpeedMessage {
  rejected: number;
  accepted: number;
  is_total: boolean; // true for admin
}

export interface AlgoSpeedEvent extends ISpeedMessage {
  is_total: boolean; // true for admin
  hash: string;
  rejected: number;
  accepted: number;
  only_admin: boolean;
  only_users: boolean;
}

export function isMinerHashEvent(
  event: MinerBaseEvent<string | undefined>
): event is MinerHashEvent {
  return (
    (event as MinerHashEvent).speed !== undefined &&
    (event as MinerHashEvent).rejected !== undefined &&
    (event as MinerHashEvent).accepted !== undefined
  );
}

// Старт/стоп майнинга на админа
// Type=3
export interface MinerAdminMiningEvent extends MinerBaseEvent<string | undefined> {
  admin_mining: boolean; //true - если начал майнить на админа, false - закончил
}

// Старт/стоп майнера
//Type=4
export interface MinerStartStopEvent extends MinerBaseEvent<string | undefined> {
  action: string; //start/stop
  reason: string; //user/plan
  new_status: number;
}

/*
Вариант для админа
{"id":1665499264856147474,"type":5,"event":{"id":62,"is_total":true,"speed":240100673655751.78,"created":1665499264}}
Вариант для юзера
{"id":1665499264874024049,"type":5,"event":{"id":62,"is_total":false,"speed":104752887862191.14,"created":1665499264}}
*/


export function isMinerSettingsSpeedEvent(
  event: MinerBaseEvent<string | undefined>
): event is MinerSettingsSpeedEvent {
  const asNeed = event as AlgoSpeedEvent;
  return (
    asNeed.is_total !== undefined &&
    typeof asNeed.hash === "undefined" &&
    asNeed.speed !== undefined
  );
}

/*
Варианта для админа
{"id":1665498288954324793,"type":6,"event":{"hash":"sha256","is_total":true,"speed":3470932886999778,"created":1665498288}}
Вариант для юзера
{"id":1665498288958765125,"type":6,"event":{"hash":"sha256","is_total":false,"speed":135023081560050.48,"created":1665498288}}
*/

export function isAlgoSpeedEvent(
  event: MinerBaseEvent<string | undefined>
): event is AlgoSpeedEvent {
  const asAlgoSpeed = event as AlgoSpeedEvent;
  return (
    asAlgoSpeed.is_total !== undefined &&
    asAlgoSpeed.hash !== undefined &&
    asAlgoSpeed.speed !== undefined
  );
}
/*
export interface MinerHashSpeedForChartEvent extends MinerBaseEvent {
  Speed : number;
} */

export interface MinerIdEvent extends MinerBaseEvent<string | undefined> {
  miner_id: string; // in table
}

export interface MinerLocationEvent extends MinerBaseEvent<string | undefined> {
  location_id: number;
  name: string;
}

export interface MinerTypeEvent extends MinerBaseEvent<string | undefined> {
  type: IMinerProfile;
}

export interface MinerDefaultSpeedEvent extends MinerBaseEvent<string | undefined> {
  speed: number;
}

export interface MinerDropSpeedEvent extends MinerBaseEvent<string | undefined> {
  speed: number;
  notifications: string[];
}

export interface IMinerSettings {
  setting_id: string;
  name: string;
  is_own_mining: boolean;
}
export interface MinerSettingsEvent extends MinerBaseEvent<string | undefined>, IMinerSettings { }

export interface MinerCustomerEvent extends MinerBaseEvent<string | undefined> {
  customer_id: string;
  customer_uuid: string;
  customer_email: string;
  customer_name: string;
}

export interface MinerPlanEvent extends MinerBaseEvent<string | undefined> {
  plan_id: number;
}

interface IMiningToAdmin {
  day: string;
  range: number[][];
}
export interface MinerPercentEvent extends MinerBaseEvent<string | undefined> {
  setting_id: number;
  percent: number;
  admin_time: IAdminMinerProof[];
}

export interface MinerSmoothEvent extends MinerBaseEvent<string | undefined> {
  // id: string; //Id майнера
  smooth: boolean; //"гладкий" режим расчета хэшрейта
  // created: number; //время события unixtime
}

export interface ChangeRackItemPos extends MinerBaseEvent<string | undefined> {
  readonly rack_id: number;
  readonly rack_item_id: number;
}

export interface ChangeUserColor extends UserBaseEvent {
  readonly color: string;
}
